import React from "react";

export default function Loading() {

    return (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen bg-black opacity-40"></div>
            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-14 py-14 ">
                <div
                    className='inline-flex items-center justify-center'
                    style={{ width: 48, height: 48 }}
                    aria-label="loading"
                >
                    <svg
                        className="animate-spin"
                        width={48}
                        height={48}
                        viewBox="0 0 50 50"
                    >
                        <defs>
                            <linearGradient id="g" x1="0%" x2="100%">
                                <stop offset="0%" stopColor="#E9EDF5" />
                                <stop offset="50%" stopColor="#E0E1F9" />
                                <stop offset="100%" stopColor="#4355B9" />
                            </linearGradient>
                        </defs>

                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="rgba(0,0,0,0.08)"
                            strokeWidth="6"
                        />
                        <path
                            d="M25 5
             a20 20 0 0 1 0 40"
                            stroke="url(#g)"
                            strokeWidth="6"
                            strokeLinecap="round"
                            fill="none"
                        />
                    </svg>
                </div>
            </div>
        </>
    );
}
